import { FC } from 'react';
import { Question, QuestionOption } from '../../Questionnaire';
import { HandleInputChangeType } from '../Question';
import {
  Option,
  OptionInput,
  OptionLabel,
  GridOptions,
  GridLastOptions,
} from '../question.styles';

interface Props {
  item: Question;
  selectedAnswers: QuestionOption[];
  handleInputChange: HandleInputChangeType;
  numberOfItemsInLastRow?: number;
}

const GridQuestionLayout: FC<Props> = ({
  item,
  handleInputChange,
  selectedAnswers,
  numberOfItemsInLastRow = 3,
}) => {
  if (item.questionOptions === undefined) {
    return null;
  }

  const cutIndex = item.questionOptions.length - numberOfItemsInLastRow;
  const first = item.questionOptions.slice(0, cutIndex);
  const second = item.questionOptions.slice(-numberOfItemsInLastRow);

  return (
    <>
      <GridOptions areTwoColumns={item.questionId === 'question_6'}>
        {first.map((option) => (
          <Option key={option.id}>
            <OptionInput
              id={option.id}
              name={item.questionId}
              onChange={(e) => handleInputChange(e, option, item.isMultiChoice)}
              type={item.isMultiChoice ? 'checkbox' : 'radio'}
              value={option.value}
              checked={
                selectedAnswers.filter((item) => item.id === option.id).length >
                0
              }
            />
            <OptionLabel
              htmlFor={option.id}
              inputType={item.isMultiChoice ? 'checkbox' : 'radio'}
            >
              {option.value}
            </OptionLabel>
          </Option>
        ))}
      </GridOptions>
      <GridLastOptions numberOfItemsInLastRow={numberOfItemsInLastRow}>
        {second.map((option) => (
          <Option key={option.id}>
            <OptionInput
              id={option.id}
              name={item.questionId}
              onChange={(e) => handleInputChange(e, option, item.isMultiChoice)}
              type={item.isMultiChoice ? 'checkbox' : 'radio'}
              value={option.value}
              checked={
                selectedAnswers.filter((item) => item.id === option.id).length >
                0
              }
            />
            <OptionLabel
              htmlFor={option.id}
              inputType={item.isMultiChoice ? 'checkbox' : 'radio'}
            >
              {option.value}
            </OptionLabel>
          </Option>
        ))}
      </GridLastOptions>
    </>
  );
};

export default GridQuestionLayout;
